import { useTranslation } from "react-i18next";
import "../../../styles/mapStyles/Popup.css";

function GeneralRecommendation({ recommendation }) {
  const { t } = useTranslation();

  return (
    <>
      <strong className="results-title">{t("soil.generalRecommendations")}</strong>
      <ul className="recommendation-list">
        {/* pH */}
        {recommendation?.ph && (
          <li className="recommendation-item">
            <span className="recommendation-nutrient">pH:</span>{" "}
            {recommendation.ph.recommendationKey
              ? t(recommendation.ph.recommendationKey, recommendation.ph.recommendationParams)
              : recommendation.ph.recommendation}
          </li>
        )}

        {/* SOC */}
        {recommendation?.soc && (
          <li className="recommendation-item">
            <span className="recommendation-nutrient">SOC:</span>{" "}
            {recommendation.soc.recommendationKey
              ? t(recommendation.soc.recommendationKey, recommendation.soc.recommendationParams)
              : recommendation.soc.recommendation}
          </li>
        )}

        {/* Nitrogen */}
        {recommendation?.nitrogen && (
          <li className="recommendation-item">
            <span className="recommendation-nutrient">Nitrogen:</span>{" "}
            {recommendation.nitrogen.recommendationKey
              ? t(recommendation.nitrogen.recommendationKey, recommendation.nitrogen.recommendationParams)
              : recommendation.nitrogen.recommendation}
          </li>
        )}

        {/* Phosphorus */}
        {recommendation?.phosphorus && (
          <li className="recommendation-item">
            <span className="recommendation-nutrient">Phosphorus:</span>{" "}
            {recommendation.phosphorus.recommendationKey
              ? t(recommendation.phosphorus.recommendationKey, recommendation.phosphorus.recommendationParams)
              : recommendation.phosphorus.recommendation}
          </li>
        )}

        {/* Potassium */}
        {recommendation?.potassium && (
          <li className="recommendation-item">
            <span className="recommendation-nutrient">Potassium:</span>{" "}
            {recommendation.potassium.recommendationKey
              ? t(recommendation.potassium.recommendationKey, recommendation.potassium.recommendationParams)
              : recommendation.potassium.recommendation}
          </li>
        )}
      </ul>
    </>
  );
}

export default GeneralRecommendation;
